module.exports = __webpack_public_path__ + "static/img/common.bf9d027.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/common.png
// module id = BaRG
// module chunks = 7